/* eslint-disable import/prefer-default-export */
export function parseParams(locationSearch) {
  try {
    const search = locationSearch.substring(1);
    return JSON.parse(
      `{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`,
      (key, value) => {
        return key === '' ? value : decodeURIComponent(value);
      }
    );
  } catch (e) {
    return {};
  }
}
